import React from 'react';
import { useDarkMode } from '../hooks/useDarkMode';

/**
 * Light/Dark theme toggle button. Sun in dark mode (click → light),
 * moon in light mode (click → dark). Uses semantic tokens so it themes itself.
 */
const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggle } = useDarkMode();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to Day Mode (light)' : 'Switch to Command Mode (dark)'}
      title={isDark ? 'Day Mode' : 'Command Mode'}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg border border-line text-ink-muted hover:bg-muted hover:text-ink transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
    >
      {isDark ? (
        /* Sun */
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M12 3v1m0 16v1m8.66-9h-1M4.34 12h-1m14.95 6.36l-.7-.7M6.41 6.41l-.7-.7m12.72 0l-.7.7M6.41 17.59l-.7.7M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ) : (
        /* Moon */
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      )}
    </button>
  );
};

export { ThemeToggle };
export default ThemeToggle;
